import React from 'react';

function Footer() {
  return(
    <footer>
      <p>© 2021 Lydia Minehan-Tubic: <a href="https://github.com/LydiaMT/storefront" target="_blank" rel="noopener noreferrer">GitHub</a> </p>
      <p>React + Redux + Material UI</p>
    </footer>
  )
}

export default Footer